import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseAddMutation, IAddFn, IGetPostRequest, IFacilityTagAddUpsert } from '../../interfaces'

import config from '../../config'

const getAddFacilitiesTagsMutationRequest: IGetPostRequest = params => {
  const { airportId } = params

  return {
    method: 'post',
    url: `${config.baseUrl}/${airportId}/Facilities/AddTagsBulk`,
  }
}

const useAddFacilitiesTagsMutation: IUseAddMutation<unknown, IFacilityTagAddUpsert[]> = (params, options = {}) => {
  const request = useMemo(() => getAddFacilitiesTagsMutationRequest(params), [params])

  const addFacilitiesTags: IAddFn<IFacilityTagAddUpsert[], unknown> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<unknown, Error, IFacilityTagAddUpsert[]>({
    mutationFn: addFacilitiesTags,
    ...options,
  })

  return response
}

export default useAddFacilitiesTagsMutation
